import { Component } from '@angular/core';

@Component({
   selector: 'shipper-billing-party',
   template: `<billing-party party="shipper"></billing-party>`,
})
export class ShipperBillingPartyComponent {}
